export const currencyFormat = (
  currency: string,
  value: number,
  type: string = 'en-US'
) => {
  try {
    return new Intl.NumberFormat(type, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value)
  } catch {
    return `${currency} ${numberFormat(value)}`
  }
}

export const numberFormat = (value: number | bigint, type: string = 'en-US') =>
  new Intl.NumberFormat(type, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
